import { Stack, Typography } from "@mui/material";
import { useContext } from "react";
import BasicTooltip from "src/components/BasicTooltip";
import { getCurrency } from "src/utils/currencies";
import { fDecimalNumber } from "src/utils/formatNumber";

import Context from "../../../../../context";

// ----------------------------------------------------------------------
type Props = {
	shares: number;
	value: number;
	currency: string;
};

export const TotalValue = ({ shares, value, currency }: Props) => {
	const { theme } = useContext(Context);

	return (
		<Stack direction={"row"} alignItems={"center"} gap={2}>
			<BasicTooltip title={value ? "" : "No ha sido posible encontrar el valor."}>
				<Typography variant='body1' noWrap color={theme?.colors.primaryText}>
					{value
						? `${fDecimalNumber(value)} ${getCurrency(currency)}`
						: `N/D ${getCurrency(currency)}`}
				</Typography>
			</BasicTooltip>
			<Typography variant='body2' noWrap color={theme?.colors.primaryText}>{`${fDecimalNumber(
				shares,
				true
			)} part.`}</Typography>
		</Stack>
	);
};

export default TotalValue;
